var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cartId
    ? _c(
        "div",
        {
          staticClass: "w-full transition-all transition-250",
          class: [_vm.hiddenMd ? "block md_hidden" : "hidden md_block"]
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex justify-between items-center w-20 md_w-16 mx-auto mt-2_5 text-brand-secondary-850"
            },
            [
              _c(
                "router-link",
                {
                  staticClass:
                    "text-lg md_text-sm font-bold select-none checkout-step",
                  attrs: {
                    to: { name: _vm.cartRoute, params: { id: _vm.cartId } }
                  }
                },
                [_vm._v("Shopping Bag")]
              ),
              _c("div", {
                staticClass:
                  "border-t flex-grow border-dashed mx-1 border-border"
              }),
              _c(
                "router-link",
                {
                  staticClass:
                    "text-lg md_text-sm font-bold select-none checkout-step",
                  attrs: { to: { name: _vm.checkoutRoute } }
                },
                [_vm._v("Checkout")]
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }